import { render } from "./updateperson.vue?vue&type=template&id=2098dad6&scoped=true"
import script from "./updateperson.vue?vue&type=script&lang=js"
export * from "./updateperson.vue?vue&type=script&lang=js"

import "./updateperson.vue?vue&type=style&index=0&id=2098dad6&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2098dad6"]])

export default __exports__